import { Component, Input } from '@angular/core';
import { DialogService } from 'src/app/core/services/dailog.service';

@Component({
  selector: 'app-help-button',
  template: `
    <button mat-icon-button (click)="openHelp()" matTooltip="View help guide" class="help-btn">
      <mat-icon>help_outline</mat-icon>
    </button>
  `,
  styles: [`
    .help-btn {
      vertical-align: middle;
      opacity: 0.6;
      &:hover { opacity: 1; }
    }
  `]
})
export class HelpButtonComponent {
  @Input() guideKey: string = '';

  constructor(private dialogService: DialogService) {}

  openHelp() {
    this.dialogService.viewGuide({ key: this.guideKey, area: 'admin', readOnly: true });
  }
}
